"use strict";
// 这个是用来标记类属性的
// 被装饰的属性 被实例原型deps数组所收集
exports.__esModule = true;
exports.State = void 0;
var bce_helper_1 = require("@baidu/bce-helper");
function State(isResetWhenDestroy) {
    if (isResetWhenDestroy === void 0) { isResetWhenDestroy = true; }
    return function (target, propertyKey) {
        if (!(0, bce_helper_1.isArray)(target.__proto__.deps)) {
            target.__proto__.deps = [];
        }
        target.__proto__.deps.push({
            key: propertyKey,
            isReset: isResetWhenDestroy
        });
    };
}
exports.State = State;
